import type {
  GetDataOptions,
  SaveDataOptions,
  StorageRepository,
} from '../../domain/interfaces/StorageRepository';

export class StorageService {
  constructor(private readonly repo: StorageRepository) {}

  localSaveData<T>(key: string, value: T, options: SaveDataOptions): void {
    this.repo.localSaveData(key, value, options);
  }
  localGetData<T>(key: string, options?: GetDataOptions): T | null {
    return this.repo.localGetData<T>(key, options);
  }
  sessionSaveData<T>(key: string, value: T, options: SaveDataOptions): void {
    this.repo.sessionSaveData(key, value, options);
  }
  sessionGetData<T>(key: string, options?: GetDataOptions): T | null {
    return this.repo.sessionGetData<T>(key, options);
  }
  cookieSaveData<T>(key: string, value: T, options: SaveDataOptions): void {
    this.repo.cookieSaveData(key, value, options);
  }
  cookieGetData<T>(key: string, options?: GetDataOptions): T | null {
    return this.repo.cookieGetData<T>(key, options);
  }
}

